export default __webpack_public_path__ + "static/media/item_3.b6231ebd.webp";